<template>
  <div class="home">
    <div class="page-container">
      <div class="user-card">
        <div class="card-top">
          <div class="user-info" v-if="imgLoaded">
            <div class="user-avatar"
              :style="{
                backgroundImage: 'url(' + user.headimgurl + ')'
              }"
            ></div>
            <div class="user-name">{{ user.nickname }}</div>
          </div>
          <div class="user-code" @click="showQr">
            <van-icon name="qr" />
          </div>
        </div>
        <div class="user-finance">
          <div class="title-card">红包剩余（元）</div>
          <div class="money">
            {{ user.distributor ? user.distributor.red_pack : 0 }}
          </div>
          <div class="tips">为了保证红包正常发送，请及时充值。</div>
        </div>

        <!--
        <div class="charge-function">
          <van-button block round type="primary" @click="doCharge">充值红包</van-button>
        </div>

        <div class="user-finance sms">
          <div class="title-card">短信余额（条）</div>
          <div class="money">
            {{ user.distributor ? user.distributor.sms : 0 }}
          </div>
        </div>

        <div class="user-finance traffic">
          <div class="title-card">流量余额</div>
          <div class="money">
            {{ user.distributor ? ((user.distributor.traffic - (user.traffic_today ?? 0))/1000/1000/1000).toFixed(1) + 'G' : 0 }}
          </div>
        </div>
        -->
        <div class="charge-function">
          <van-button block round color="#ff6f52" @click="doCharge">红包充值</van-button>
          <van-button block round type="primary" @click="doChargeRecord">充值记录</van-button>
        </div>
      </div>
    </div>
    <van-popup v-model="showQrcode" style="background: transparent">
      <div class="qrcode">
        <img :src="inviteQr" />
      </div>
    </van-popup>
    <Footer />
    <DisError />
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Footer from '@/components/Footer.vue'
import DisError from './component/DisError.vue';
import { mapState } from 'vuex'

export default {
  name: 'DisIndex',
  components: {
    Footer, DisError
  },
  data() {
    return {
      showQrcode: false,
      inviteQr: '',
      imgLoaded: false,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    'user': 'initAvatar'
  },
  async mounted() {
    await this.initAvatar();
  }, 
  methods: {
    async initAvatar() {
      if (!this.user || !this.user.headimgurl) return;
      let avatar = await (new Promise((resolve, reject) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => {
          resolve(img)
        }
        img.src = this.user.headimgurl
      }))
      this.imgLoaded = true;
    },
    async initQr() {
      if (this.inviteQr) return;
      if (!this.user || !this.user.invite_link) return;

      let shareBg = await (new Promise((resolve, reject) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => {
          resolve(img)
        }
        img.src = './share.png?t=1'
      }))
      // let avatar = await (new Promise((resolve, reject) => {
      //   let img = new Image()
      //   img.crossOrigin = 'Anonymous'
      //   img.onload = () => {
      //     resolve(img)
      //   }
      //   img.src = this.user.headimgurl
      // }))

      let canvas = document.createElement('canvas')
      canvas.width = 360
      canvas.height = 540
      var ctx = canvas.getContext('2d')
      // ctx.drawImage(avatar, 136, 48, 80, 80);
      // ctx.fillStyle = '#555555'
      // ctx.font = '20px "微软雅黑", Tahoma, sans-serif, "Hiragino Sans GB"'
      // ctx.fillText('' + this.shareInfo.author, 600, 80)
      ctx.drawImage(shareBg, 0, 0);
      let qrcode = await QRCode.toCanvas(this.user.invite_link, {
        margin: 0,
      })
      ctx.drawImage(qrcode, 98, 180, 180, 180)

      ctx.lineWidth = 3
      ctx.font = '18px "微软雅黑", Tahoma, sans-serif, "Hiragino Sans GB"'
      ctx.textAlign = 'center'
      ctx.fillStyle = 'white'
      ctx.fillText(this.user.nickname, 185, 400)

      this.inviteQr = canvas.toDataURL('image/jpeg')
    },
    async showQr() {
      await this.initQr();
      this.showQrcode = true;
    },
    doCharge() {
      this.$router.push('/DisCharge')
    },
    doChargeRecord() {
      this.$router.push('/DisChargeRecord')
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  padding-bottom: 50px;
}
.user-card {
  background: #ffffff;
  padding: 15px;
  border-radius: 5px;

  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;

    .user-info {
      display: flex;
      align-items: center;

      .user-avatar {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        margin-right: 10px;
        background-size: cover;
        background-position: center;
      }

      .user-name {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .user-code {
      font-size: 36px;
    }
  }

  .user-finance {
    background: #90d3aa;
    border-radius: 15px;
    ;
    padding-bottom: 10px;
    margin-bottom: 25px;

    .title-card {
      overflow: hidden;
      border-bottom-right-radius: 15px;
      width: 50%;
      width: fit-content;
      padding: 10px 20px;
      color: #5c9b73;
      background: rgba(255, 255, 255, 0.6);
    }

    &.sms {
      background: #7684e7;
      .title-card {
        color: #3041c0;
      }
    }
    &.traffic {
      background: #ff6f52;

      .title-card {
        color: #cd5a43;
      }
    }
    .money {
      padding: 20px 0 20px 30px;
      font-size: 36px;
      color: #fff;
    }

    .tips {
      padding: 10px 20px;
      color: #ffffff;
    }

  }

  .charge-function {
    margin-bottom: 25px;
    display: flex;
    gap: 10px;
  }
}

.qrcode {
  width: 90vw;
  border-radius: 20px;
  overflow: hidden;
  padding: 0;
  margin: 0;

  img {
    width: 100%;
    padding: 0;
    margin: 0;
  }
}
</style>
